/** Convert Celsius to Fahrenheit */
export function toFahrenheit(celsius: number): number {
  return celsius * 9 / 5 + 32;
}

/** Convert temperature value based on target unit */
export function convertTemperature(value: number | null | undefined, unit: string): number | null {
  if (value === null || value === undefined) return null;
  return unit === 'F' ? parseFloat(toFahrenheit(value).toFixed(2)) : value;
}

/** Get temperature unit label */
export function tempUnitLabel(unit: string): string {
  return unit === 'F' ? '°F' : '°C';
}

/** Get current user's preferred temperature unit from localStorage */
export function getStoredTempUnit(): string {
  return localStorage.getItem('temperature_unit') || 'C';
}

/** Store user's preferred temperature unit in localStorage */
export function setStoredTempUnit(unit: string): void {
  localStorage.setItem('temperature_unit', unit);
}

